// PWA
import { init } from "./includes/service-worker/pwa"
init()

import "./includes/dayjs"

// Setup Swiper Element
import { register } from 'swiper/element/bundle'
register()

import { sentryInit } from "./includes/sentry"

// Important for security. Strip "data" parameter from URL if it's not terms-and-conditions page where it is expected
if(location.search.indexOf('data') === 1 && !location.pathname.indexOf("terms-and-conditions")){
	window.history.replaceState(false, '', location.pathname)
}

// Import dom-slider to the global scope
import "dom-slider"

// Setup router 
import { router } from "@/js/routes"
import { createApp } from 'vue'

import VueLazyload from 'vue3-lazyload'
import { createGtag } from "vue-gtag"

import Loader from './components/loader.vue'
import Checkbox from './components/checkbox.vue'
import Radio from './components/radio.vue'

import TransitionHeight from "./components/blocks/transition-height.vue"
import ResponsiveImage from './components/blocks/responsive-image.vue'
import ResponsiveChallengeImage from './components/blocks/responsive-challenge-image.vue'

import "./includes/font-awesome"
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Import Vue app
import App from "./components/app.vue"
import { setupOauth } from "./includes/auth"

// Create the app
const app = createApp(App)

// Import axios
import userAxios from './includes/axios'
app.provide("axios", userAxios) // We must use provide/inject to prevent axios conflict with user instance

// Adding PrimeVue/Toast
import PrimeVue from "primevue/config";
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import Aura from '@primeuix/themes/aura';

// Import Toast
app.use(ToastService);
app.component('Toast', Toast);

app.use(PrimeVue, {
	// theme: 'none',
	theme: {
		preset: Aura,
		options: {
			prefix: 'p',
			darkModeSelector: 'selector',
			cssLayer: false
		}
	},
})

// Import and setup Pinia stores for user env
import { createPinia } from 'pinia'
import { useStore } from "./stores/index"

const pinia = createPinia()
app.use(pinia)

const store = useStore()

// Load lazyloader for challenge images
app.use(VueLazyload, {
	error: '/customer/images/image-spinner.gif',
	loading: '/customer/images/image-spinner.gif',
})

// Register plugins
app.use(router)

// Register global components
app.component('loader', Loader)
app.component('checkbox', Checkbox)
app.component('radio', Radio)
app.component('ResponsiveImage', ResponsiveImage)
app.component('ResponsiveChallengeImage', ResponsiveChallengeImage)

// Registed fake BootstrapVue components to avoid Vue reporting about those
import createBootstrapVuePlaceholders from "./includes/bootstrap-vue.placeholding"
createBootstrapVuePlaceholders(app)

// Adding height transitions
app.component("TransitionHeight", TransitionHeight)

// New font-awesome inclusion (version 5+)
app.component('FontAwesomeIcon', FontAwesomeIcon)

// Mount the app and make it a global shortcut
app.provide('appInstance', app)

// Request settings 
userAxios.get('/api/user-side/getSettings', {
	params: {
		url: document.location.pathname.substring(1),
	}
})
.then(({ data: settings }) => {
	settings.masterServerUrl = "" // This is for the compatibility with manage env
	
	store.settings = settings
	store.colorTheme = document.documentElement.dataset?.theme || ""

	if(settings.authenticated == false){
		store.authenticated = false
	}

	// Setup all authentication subsystem
	setupOauth(app)

	sentryInit({
		app,
		dsn: settings.sentryUrl,
		release: "challenger@" + window.__deploymentVersion,
		router,
		replay: true,
		tracesSampleRate: 1.0,
	})

	// Setup Google Analytics and track event
	if(settings.googleAnalyticsTrackingId){
		createGtag({
			tagId: settings.googleAnalyticsTrackingId,
			pageTracker: {
				router
			}
		})
	}
	
	// Mount the app
	window.$app = app.mount("#challengerApp")
})
.catch(() => {
	store.offline = true
})

// Set Vite to reload if preload fails
// https://vitejs.dev/guide/build#load-error-handling
window.addEventListener('vite:preloadError', () => {
  window.location.reload() // for example, refresh the page
})